import { __spreadValues as i } from "./3YLGPPWQ.js";
import { hasOwnProperty as c } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { isValidElement as s } from "react";
function m(t, o) {
  typeof t == "function" ? t(o) : t && (t.current = o);
}
function e(t) {
  return !t || !s(t) ? !1 : "ref" in t.props || "ref" in t;
}
function V(t) {
  return e(t) ? i({}, t.props).ref || t.ref : null;
}
function h(t, o) {
  const r = i({}, t);
  for (const f in o) {
    if (!c(o, f)) continue;
    if (f === "className") {
      const n = "className";
      r[n] = t[n] ? `${t[n]} ${o[n]}` : o[n];
      continue;
    }
    if (f === "style") {
      const n = "style";
      r[n] = t[n] ? i(i({}, t[n]), o[n]) : o[n];
      continue;
    }
    const p = o[f];
    if (typeof p == "function" && f.startsWith("on")) {
      const n = t[f];
      if (typeof n == "function") {
        r[f] = (...u) => {
          p(...u), n(...u);
        };
        continue;
      }
    }
    r[f] = p;
  }
  return r;
}
export {
  V as getRefProperty,
  e as isValidElementWithRef,
  h as mergeProps,
  m as setRef
};
//# sourceMappingURL=SK3NAZA3.js.map
